import { htmlToPlainText } from '@/utils/htmlSanitizer';

/**
 * What the plan page receives in the history state when it is opened right after a meeting is
 * created. The agenda generation is started from the plan itself, where its lock and its reread live,
 * and the flag is consumed once so going back and forth never starts it again.
 */
export interface PlanNavigationState {
    generateAgenda?: boolean;
}

/**
 * The state to open a newly created meeting's plan with: ask for an agenda only when the context holds
 * text. The editor hands back markup, and a field typed into then emptied is still `<p></p>`.
 */
export const getPlanNavigationState = (
    context: string | undefined,
): PlanNavigationState | undefined =>
    htmlToPlainText(context ?? '').trim() ? { generateAgenda: true } : undefined;
